<template>
    <div class="left-edit-form-wrapper scroll-tracker">
        <div class="form-info">
            <div class="form-label required">
                {{ typeLabel }}
            </div>
            <Select :labelStyle="{ color: typeColor }" :initValue="typeInit" :options="formTypeOptions" @menuClick="typeSelect" />
            <div class="form-label required">
                {{ classLabel }}
            </div>
            <Select
                class="class-selector"
                @selectClick="selectClick"
                :initValue="initSceneId"
                :topOrBottom="86"
                :options="sceneClass"
                @menuClick="sceneSelected"
            >
                <Search :placeholder="palceHolder" @searchChange="searchChange" @inputChange="searchChange" class="scene-search" />
            </Select>
            <div class="form-label required">
                {{ formNameLabel }}
            </div>
            <input :placeholder="namePlaceHolder" v-model="formName" @input="formNameChange" type="text" class="form-input" />

            <div class="form-label required">
                {{ formTitleLabel }}
            </div>
            <input :placeholder="optionPlaceHolder" v-model="formTitle" @input="formTitleChange" type="text" class="form-input" />
            <div class="form-label required">
                {{ langLabel }}
            </div>
            <LangSelect :value="langInit" class="lang-select" @change="langSelect" :requireAll="true"></LangSelect>
            <div v-show="typeInit == '2'" class="form-label">
                <div class="form-label required">
                    {{ respChannelLabel }}
                </div>
                <UserSwitchTabs :pickData="respChannel" :current="curRespChannel" @userChange="respChannelSelect" />
            </div>
        </div>
    </div>
</template>

<script>
import Select from "@/views/zhiji/bComponents/inputs/Select";
import Search from "@/views/zhiji/bComponents/inputs/Search";
import UserSwitchTabs from "@/views/zhiji/bComponents/switchs/UserSwitchTabs";
import LangSelect from "@/components/langSelect";
import { formTypeOptions } from "@/views/zhiji/pages/form/formConfig.js";
export default {
    name: "LeftEditForm",
    components: {
        Select,
        Search,
        LangSelect,
        UserSwitchTabs
    },
    props: [],
    data() {
        return {
            langInit: "all",
            formName: "",
            formTitle: "",
            initSceneId: "def",
            formTypeOptions: formTypeOptions().slice(1, formTypeOptions().length),
            typeColor: "",
            curRespChannel: ["1", "2"]
        };
    },
    computed: {
        respChannelLabel() {
            return this.$t("zhiji.form.respChannel");
        },
        respChannel() {
            return [
                {
                    label: this.$t("zhiji.form.innerGame"),
                    value: "1",
                    style: {
                        "background-color": "#fff"
                    }
                },
                {
                    label: this.$t("zhiji.form.email"),
                    value: "2",
                    style: {
                        "background-color": "#fff"
                    }
                }
            ];
        },
        typeInit() {
            return this.getStorePorp("formInfo").formType || "0";
        },
        typeLabel() {
            return this.$t("zhiji.form.type");
        },
        classLabel() {
            return this.$t("zhiji.common.classLabel");
        },
        formNameLabel() {
            return this.$t("zhiji.form.formNameLabel");
        },
        namePlaceHolder() {
            return this.$t("zhiji.form.inputFormName");
        },
        formTitleLabel() {
            return this.$t("zhiji.form.formTitleLabel");
        },
        optionPlaceHolder() {
            return this.$t("zhiji.form.defaultFormTitle");
        },
        palceHolder() {
            return this.$t("zhiji.form.searchCategories");
        },
        langLabel() {
            return this.$t("zhiji.common.language");
        },
        sceneClass() {
            let scenes = this.getStorePorp("sceneClassDatas").slice(0) || [];
            // 添加默认状态
            scenes.unshift({
                label: this.$t("zhiji.form.selectFormCategory"),
                value: "def"
            });

            return scenes;
        },
        formInfo() {
            return this.getStorePorp("formInfo");
        }
    },
    watch: {
        formInfo: {
            handler(newValue) {
                this.initValue(newValue);
            },
            immediate: true,
            deep: true
        },
        typeInit(val) {
            val === "1" ? (this.typeColor = "#fe0931") : (this.typeColor = "");
        }
    },
    methods: {
        initValue(formInfo) {
            this.langInit = formInfo.lang ? formInfo.lang : "all";
            this.formName = formInfo.name ? formInfo.name : "";
            this.formTitle = formInfo.title ? formInfo.title : "";
            this.initSceneId = formInfo.tagId ? "" + formInfo.tagId : "def";
            this.curRespChannel = formInfo.curRespChannel ? formInfo.curRespChannel : ["1", "2"];
        },
        getStorePorp(propName) {
            return this.$store.state.zhiji.formEdit[propName];
        },
        sceneSelected(sceneClass) {
            this.$store.commit("zhiji/updateFormInfo", {
                tagId: sceneClass.value
            });
        },
        selectClick() {
            this.$store.commit("zhiji/searchFormScenes", {
                field: ""
            });
        },
        formNameChange() {
            this.$store.commit("zhiji/updateFormInfo", {
                name: this.formName
            });
        },
        formTitleChange() {
            this.$store.commit("zhiji/updateFormInfo", {
                title: this.formTitle
            });
        },
        searchChange(data) {
            this.$store.commit("zhiji/searchFormScenes", {
                field: data.value
            });
        },
        langSelect(data) {
            this.$store.commit("zhiji/updateFormInfo", {
                lang: data
            });
        },
        typeSelect(data) {
            data.value === "1" ? (this.typeColor = "#fe0931") : (this.typeColor = "");
            this.$store.commit("zhiji/updateFormInfo", {
                formType: data.value
            });
            if (data.value == "2") {
                this.respChannelSelect(["1", "2"]);
            }
        },
        respChannelSelect(data) {
            this.$store.commit("zhiji/updateFormInfo", {
                curRespChannel: data
            });
        }
    }
};
</script>

<style lang="less" scoped>
.left-edit-form-wrapper {
    position: relative;
    width: 272px;
    padding: 0 18px 16px;
    font-size: 14px;
    border-right: 1px solid #d8e4f0;
    background: #f2f7fb;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    .form-label {
        margin: 20px 0 5px 0;
        font-size: 12px;

        .gray-label {
            color: #9b9ba3;
        }
        &:first-child {
            margin-top: 10px;
        }
    }

    .required {
        &:before {
            color: #fe0931;
            content: "*";
            display: inline-block;
        }
    }

    .form-input {
        border-radius: 4px;
        padding: 7px 8px;
        background: #fff;
        width: 100%;
        border: solid 1px #d8e4f0;
        box-sizing: border-box;
        color: #41475e;

        &:focus {
            border-color: #2088f3;
        }
    }

    .form-info {
        .class-selector {
            width: 235px;
            color: #9b9ba3;
        }

        .scene-search {
            width: 100%;
            position: absolute;
            left: 0;
            top: 42px;
            padding: 7px 0;
            background: #fff;
        }
    }

    .type-select {
        color: #fe0931;
    }

    .lang-select {
        width: 120px;
    }
}
</style>
